export default "__VITE_ASSET__C3sEO81z__"